import { render, staticRenderFns } from "./ResendSignUp.vue?vue&type=template&id=1f0fd2d0&scoped=true"
import script from "./ResendSignUp.vue?vue&type=script&lang=ts"
export * from "./ResendSignUp.vue?vue&type=script&lang=ts"
import style0 from "./ResendSignUp.vue?vue&type=style&index=0&id=1f0fd2d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0fd2d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0fd2d0')) {
      api.createRecord('1f0fd2d0', component.options)
    } else {
      api.reload('1f0fd2d0', component.options)
    }
    module.hot.accept("./ResendSignUp.vue?vue&type=template&id=1f0fd2d0&scoped=true", function () {
      api.rerender('1f0fd2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ResendSignUp.vue"
export default component.exports